export default "__VITE_ASSET__31X1WGfc__"